class TrialLoginForm {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.collectionsDropdown = self.elem.querySelector('[data-collections-select-menu]');
    }

    init() {
        let self = this;

        self.collectionsDropdown.addEventListener('input', evt => {
            self.elem.setAttribute('action', self.collectionsDropdown.value);
        });
    }
}

export default TrialLoginForm;